// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GetHearingDetails, DownloadOIT } from "@api";

export const getHearingDetails = createAsyncThunk(
  "hearing/get_hearing_details",
  async (args) => {
    const response = await GetHearingDetails(args);
    return response.data;
  }
);

export const downloadOIT = createAsyncThunk(
  "hearing/download_oit",
  async (args) => {
    const response = await DownloadOIT(args);
    return response.data;
  }
);

export const hearingSlice = createSlice({
  name: "hearing",
  initialState: {
    hearingDetails: {},
    isSOAAccepted: false,
    isPbosAccepted: false,
    isOITFileExists: false,
    isGrantDownloadable: false, // determine the Next btn disabled
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHearingDetails.fulfilled, (state, action) => {
      state.hearingDetails = action.payload.HearingDetails;
      state.isSOAAccepted = action.payload.IsSOAAccepted;
      state.isPbosAccepted = action.payload.IsPBOSAccepted;
      state.isOITFileExists = action.payload.IsOITExists;
      state.isGrantDownloadable = action.payload.IsGrantDownloadable;
    });
  },
});

export const hearingActions = hearingSlice.actions;
export default hearingSlice.reducer;
